export function publicAssetPath(path?: string | null) {
  const normalizedPath = path?.trim()

  if (!normalizedPath) {
    return ''
  }

  return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`
}
